import { PositionJournalValues } from './types'
import { generateExternalTransferId } from '../../utils/payloadHelpers'

const formatPayload = (values: PositionJournalValues) => {
  const sourceAccountDescription = [values.sourceAccountDescription, values.sourceAccountDescription2].filter(
    (val) => !!val
  )
  const destinationAccountDescription = [
    values.destinationAccountDescription,
    values.destinationAccountDescription2
  ].filter((val) => !!val)

  return {
    externalId: generateExternalTransferId(),
    quantity: values.quantity,
    securityIdType: values.securityCodeType,
    securityId: values.securityId,
    amount: values.amount,
    sourceAccount: values.fromAccount,
    destinationAccount: values.toAccount,
    ...(sourceAccountDescription.length > 0 && { sourceAccountDescription }),
    ...(destinationAccountDescription.length > 0 && { destinationAccountDescription }),
    journalType: values.journalType
  }
}

export default formatPayload
